"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var flexStyles = require("@headspace/hs-web-style-guide/dist/flex");

var styles_1 = require("./styles");

var _a = flexStyles.default,
    flex = _a.flex,
    alignItemsCenter = _a.alignItemsCenter,
    justifyContentAround = _a.justifyContentAround;

exports.CheckboxInput = function (_a) {
  var onChange = _a.onChange,
      label = _a.label,
      value = _a.value,
      tabIndex = _a.tabIndex,
      id = _a.id,
      customInputStyles = _a.customInputStyles;
  return React.createElement("label", __assign({}, flex, alignItemsCenter, justifyContentAround, styles_1.checkboxStyle, styles_1.inputOptions(customInputStyles)), React.createElement("input", {
    type: "checkbox",
    id: id,
    onChange: onChange,
    defaultChecked: value,
    value: value,
    tabIndex: tabIndex
  }), React.createElement("div", {
    role: "checkbox",
    className: "checkboxDisplay " + (value ? 'checked' : '')
  }), React.createElement("span", {
    className: "checkboxLabel"
  }, label));
};